import { OrderStatusEnum } from '@authority-labs/enums';
import { BaseDto } from './base.dto';

export class OrderStatus extends BaseDto {
  key?: OrderStatusEnum | string;
  name?: string;
  readonly?: boolean;
}
